import {
  type Configuration,
  LogLevel,
  PublicClientApplication
} from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: "", // will be overwritten in getMsalInstance
    redirectUri: new URL("/login/redirect", new URL("/", import.meta.url).href)
      .href
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii || !import.meta.env.DEV) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const getMsalInstance = (clientId: string, tenantId: string) => {
  msalConfig.auth.clientId = clientId;
  msalConfig.auth.authority = `https://login.microsoftonline.com/${tenantId}/v2.0`;
  loginRequest.scopes = [`api://${clientId}/default`, "profile"];
  return new PublicClientApplication(msalConfig);
};

export const loginRequest = {
  scopes: ["profile"]
};
